import { AppState } from '../types'

export const isRioInitSelector = (state: AppState) => state.instrumentation.isRioInit
